// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-bar {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

/* Contenedor del textarea y botones */
.chat-input-wrapper {
  position: relative;
  padding: 0px 12px 12px 12px;
  background: linear-gradient(135deg, #24272b, #2c3137);
  border: 1px solid #334155;
  border-radius: 24px;
  color: #f1f5f9;
  display: flex;
  flex-direction: column;
  gap: 5px;
  height: auto;
  max-height: 130px;
  min-height: 20px;
}

/* Textarea */
.chat-input {
  width: 98%;
  padding: 12px 10px;
  border-radius: 12px;
  font-size: 14px;
  color: #f1f5f9;
  background-color: transparent;
  border: none;
  resize: none;
  outline: none;
  line-height: 1.5;
  min-height: 10px;
  max-height: 90px;
  overflow-y: auto;
  scrollbar-width: none;
}

/* Botones debajo del textarea alineados a la izquierda */
.chat-input-actions.left-aligned {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 4px;
}

/* Estilo base para botones de acción */
.action-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 500;
  color: #e2e8f0;
  border: 1px solid #334155;
  border-radius: 12px;
  background-color: transparent;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.action-btn:hover {
  background-color: #334155;
  border-color: #475569;
}

/* Subir archivo */
.file-btn input[type="file"] {
  display: none;
}

/* Botón de envío (estilo animado) */
.send-btn {
  display: flex;
  align-items: center;
  font-size: 13px;
  background: #0e1923;
  color: white;
  padding: 8px 14px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  overflow: hidden;
  margin-left: auto;
  transition: all 0.2s ease;
}

.send-btn:hover {
  background: #8888910f;
}

.send-btn span {
  margin-left: 6px;
}

.send-btn svg {
  width: 1.4em;
  height: 1.4em;
  transition: transform 0.3s ease-in-out;
}

.send-btn:hover .send-icon {
  transform: translateX(3px) rotate(45deg);
}

/* Vista previa del archivo seleccionado */
.file-preview {
  display: flex;
  align-items: center;
  width: fit-content;
  justify-content: space-between;
  background: #b2b4b5;
  color: #090909;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 14px;
  margin-top: 4px;
}

/* Botón para eliminar archivo */
.delete-file {
  background: none;
  border: none;
  color: #000000;
  font-size: 16px;
  font-weight: 800;
  cursor: pointer;
}

.delete-file:hover {
  color: #0e79d0;
  font-weight: 900;
}

/* Acciones cuando hay archivo (Resumir / Mapa / Leer) */
.file-action-buttons {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.btn-resumir,
.btn-concept-map,
.read-file {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  font-size: 13px;
  background: #2b3d49;
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.btn-concept-map:hover,
.btn-resumir:hover,
.read-file:hover {
  background: #266ea0;
}

/* Contenedor del botón "Ver Mapa" */
.concept-map-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 6px;
}

/* Botón Chat de Voz con animación */
.bn632-hover {
  width: 140px;
  height: 44px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  border: none;
  background-size: 300% 100%;
  border-radius: 12px;
  transition: all 0.4s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.bn632-hover:hover {
  background-position: 100% 0;
}

.bn632-hover.bn18 {
  background-image: linear-gradient(
    to right,
    #083d53,
    #27819c,
    #18bfc5,
    #031d22
  );
  box-shadow: 0 4px 15px 0 rgba(49, 196, 190, 0.75);
}

.button-text {
  transition: opacity 0.3s ease;
}

.icon-container {
  display: none;
}

.bn632-hover:hover .button-text {
  display: none;
}

.bn632-hover:hover .icon-container {
  display: inline-flex;
  font-size: 18px;
}

/* Responsive */
@media (max-width: 768px) {
  .chat-input-wrapper {
    padding: 8px;
    border-radius: 16px;
    gap: 4px;
  }

  .chat-input {
    width: 100%;
    font-size: 13px;
    padding: 10px;
    min-height: 40px;
    max-height: 120px;
    line-height: 1.4;
  }

  .chat-input-actions.left-aligned {
    flex-wrap: wrap;
    gap: 6px;
    justify-content: flex-start;
  }

  .action-btn {
    padding: 6px 10px;
    font-size: 12px;
    border-radius: 8px;
  }

  .send-btn {
    font-size: 12px;
    padding: 6px 10px;
    border-radius: 8px;
  }

  .bn632-hover {
    width: 100%;
    height: 40px;
    font-size: 13px;
    margin-top: 6px;
  }

  .file-preview {
    font-size: 13px;
    padding: 5px 8px;
    max-width: 100%;
    flex-wrap: wrap;
  }

  .file-action-buttons {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 6px;
  }

  .btn-resumir,
  .btn-concept-map,
  .read-file {
    font-size: 12px;
    padding: 6px 10px;
    border-radius: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/chat/ChatBar/ChatBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,qDAAqD;EACrD,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;;;;;;GAMC;EACD,iDAAiD;AACnD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,YAAY;IACZ,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,QAAQ;EACV;;EAEA;;;IAGE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;AACF","sourcesContent":[".chat-bar {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n/* Contenedor del textarea y botones */\n.chat-input-wrapper {\n  position: relative;\n  padding: 0px 12px 12px 12px;\n  background: linear-gradient(135deg, #24272b, #2c3137);\n  border: 1px solid #334155;\n  border-radius: 24px;\n  color: #f1f5f9;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  height: auto;\n  max-height: 130px;\n  min-height: 20px;\n}\n\n/* Textarea */\n.chat-input {\n  width: 98%;\n  padding: 12px 10px;\n  border-radius: 12px;\n  font-size: 14px;\n  color: #f1f5f9;\n  background-color: transparent;\n  border: none;\n  resize: none;\n  outline: none;\n  line-height: 1.5;\n  min-height: 10px;\n  max-height: 90px;\n  overflow-y: auto;\n  scrollbar-width: none;\n}\n\n/* Botones debajo del textarea alineados a la izquierda */\n.chat-input-actions.left-aligned {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-top: 4px;\n}\n\n/* Estilo base para botones de acción */\n.action-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #e2e8f0;\n  border: 1px solid #334155;\n  border-radius: 12px;\n  background-color: transparent;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.action-btn:hover {\n  background-color: #334155;\n  border-color: #475569;\n}\n\n/* Subir archivo */\n.file-btn input[type=\"file\"] {\n  display: none;\n}\n\n/* Botón de envío (estilo animado) */\n.send-btn {\n  display: flex;\n  align-items: center;\n  font-size: 13px;\n  background: #0e1923;\n  color: white;\n  padding: 8px 14px;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  overflow: hidden;\n  margin-left: auto;\n  transition: all 0.2s ease;\n}\n\n.send-btn:hover {\n  background: #8888910f;\n}\n\n.send-btn span {\n  margin-left: 6px;\n}\n\n.send-btn svg {\n  width: 1.4em;\n  height: 1.4em;\n  transition: transform 0.3s ease-in-out;\n}\n\n.send-btn:hover .send-icon {\n  transform: translateX(3px) rotate(45deg);\n}\n\n/* Vista previa del archivo seleccionado */\n.file-preview {\n  display: flex;\n  align-items: center;\n  width: fit-content;\n  justify-content: space-between;\n  background: #b2b4b5;\n  color: #090909;\n  padding: 6px 10px;\n  border-radius: 8px;\n  font-size: 14px;\n  margin-top: 4px;\n}\n\n/* Botón para eliminar archivo */\n.delete-file {\n  background: none;\n  border: none;\n  color: #000000;\n  font-size: 16px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.delete-file:hover {\n  color: #0e79d0;\n  font-weight: 900;\n}\n\n/* Acciones cuando hay archivo (Resumir / Mapa / Leer) */\n.file-action-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.btn-resumir,\n.btn-concept-map,\n.read-file {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  font-size: 13px;\n  background: #2b3d49;\n  color: white;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.btn-concept-map:hover,\n.btn-resumir:hover,\n.read-file:hover {\n  background: #266ea0;\n}\n\n/* Contenedor del botón \"Ver Mapa\" */\n.concept-map-actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 6px;\n}\n\n/* Botón Chat de Voz con animación */\n.bn632-hover {\n  width: 140px;\n  height: 44px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #fff;\n  cursor: pointer;\n  border: none;\n  background-size: 300% 100%;\n  border-radius: 12px;\n  transition: all 0.4s ease-in-out;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.bn632-hover:hover {\n  background-position: 100% 0;\n}\n\n.bn632-hover.bn18 {\n  background-image: linear-gradient(\n    to right,\n    #083d53,\n    #27819c,\n    #18bfc5,\n    #031d22\n  );\n  box-shadow: 0 4px 15px 0 rgba(49, 196, 190, 0.75);\n}\n\n.button-text {\n  transition: opacity 0.3s ease;\n}\n\n.icon-container {\n  display: none;\n}\n\n.bn632-hover:hover .button-text {\n  display: none;\n}\n\n.bn632-hover:hover .icon-container {\n  display: inline-flex;\n  font-size: 18px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .chat-input-wrapper {\n    padding: 8px;\n    border-radius: 16px;\n    gap: 4px;\n  }\n\n  .chat-input {\n    width: 100%;\n    font-size: 13px;\n    padding: 10px;\n    min-height: 40px;\n    max-height: 120px;\n    line-height: 1.4;\n  }\n\n  .chat-input-actions.left-aligned {\n    flex-wrap: wrap;\n    gap: 6px;\n    justify-content: flex-start;\n  }\n\n  .action-btn {\n    padding: 6px 10px;\n    font-size: 12px;\n    border-radius: 8px;\n  }\n\n  .send-btn {\n    font-size: 12px;\n    padding: 6px 10px;\n    border-radius: 8px;\n  }\n\n  .bn632-hover {\n    width: 100%;\n    height: 40px;\n    font-size: 13px;\n    margin-top: 6px;\n  }\n\n  .file-preview {\n    font-size: 13px;\n    padding: 5px 8px;\n    max-width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .file-action-buttons {\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 6px;\n  }\n\n  .btn-resumir,\n  .btn-concept-map,\n  .read-file {\n    font-size: 12px;\n    padding: 6px 10px;\n    border-radius: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
